/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Image: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1 2H23C23.2652 2 23.5196 2.10536 23.7071 2.29289C23.8946 2.48043 24 2.73478 24 3V21C24 21.2652 23.8946 21.5196 23.7071 21.7071C23.5196 21.8946 23.2652 22 23 22H1C0.734784 22 0.48043 21.8946 0.292893 21.7071C0.105357 21.5196 0 21.2652 0 21V3C0 2.73478 0.105357 2.48043 0.292893 2.29289C0.48043 2.10536 0.734784 2 1 2ZM22 14.3V4H2V17.238L5.232 13.358C5.32104 13.2514 5.43131 13.1645 5.55579 13.1029C5.68028 13.0412 5.81623 13.0062 5.955 13C6.09391 12.9932 6.23269 13.0157 6.36228 13.0662C6.49187 13.1167 6.60934 13.194 6.707 13.293L9.948 16.537L16.248 9.342C16.3362 9.22701 16.4515 9.13561 16.5836 9.07594C16.7156 9.01627 16.8604 8.99018 17.005 9C17.1484 9.00085 17.29 9.03255 17.4201 9.09294C17.5502 9.15333 17.6658 9.241 17.759 9.35L22 14.3ZM11 8C11 9.10457 10.1046 10 9 10C7.89543 10 7 9.10457 7 8C7 6.89543 7.89543 6 9 6C10.1046 6 11 6.89543 11 8Z'
      fill='currentColor'
    />
  </React.Fragment>
)
